module.exports = __webpack_public_path__ + "img/zsplus.dfc25eaf.jpg";